<template>
  <div class="about">
    <!-- 顶部 banner：底图自带右侧插画，左侧叠加文案 -->
    <div class="banner">
      <div class="banner-inner">
        <h1 class="banner-title aw-anim">云稼农业平台定位与愿景</h1>
        <p class="banner-desc aw-anim">
          面向农业全产业链，赋能政府、经营主体与金融机构，用
          AI与数据能力打造农业产业智能生态
        </p>
        <button class="banner-btn aw-anim" @click="onConsult">
          立即咨询
          <i class="el-icon-right"></i>
        </button>
      </div>
    </div>

    <!-- ============ 平台定位 ============ -->
    <section class="platform-section">
      <h2 class="section-title aw-anim">平台定位</h2>
      <div class="platform-body">
        <div class="platform-img">
          <img
            src="@/assets/about/platform_circle.png"
            alt="云稼平台生态角色图"
          />
        </div>
        <p class="platform-desc aw-anim">
          云稼农业产业互联网智能生态平台是连接农业产业主体、业务场景和数据智能能力的统一平台，通过统一底座与数据智能形成从生产到交易的数字化闭环，服务于政府、企业、农场等八大类产业角色。
        </p>
      </div>
    </section>

    <!-- ============ 核心价值 ============ -->
    <section class="value-section">
      <h2 class="section-title aw-anim">核心价值</h2>
      <div class="value-grid">
        <div
          class="value-card aw-anim"
          v-for="(item, index) in coreValues"
          :key="index"
        >
          <img class="value-icon" :src="item.icon" alt="" />
          <p class="value-desc">{{ item.desc }}</p>
        </div>
      </div>
    </section>

    <!-- ============ 服务对象 ============ -->
    <section class="service-section">
      <h2 class="section-title aw-anim">服务对象</h2>
      <div class="service-card">
        <div class="service-tabs">
          <div
            v-for="(tab, index) in serviceTabs"
            :key="index"
            class="service-tab"
            :class="{ active: serviceActive === index }"
            @click="serviceActive = index"
          >
            {{ tab.name }}
          </div>
        </div>
        <div class="service-content">
          <div
            class="service-role aw-anim"
            v-for="(role, index) in serviceTabs[serviceActive].roles"
            :key="index"
          >
            <h3 class="role-title">{{ role.title }}</h3>
            <p class="role-desc">{{ role.desc }}</p>
            <div class="role-tags">
              <span
                class="role-tag"
                v-for="(tag, tagIndex) in role.tags"
                :key="tagIndex"
                >{{ tag }}</span
              >
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- ============ 在线留言 ============ -->
    <ContactMessageForm />
  </div>
</template>
<script>
import ContactMessageForm from "@/components/ContactMessageForm.vue";

export default {
  name: "About",
  components: { ContactMessageForm },
  data() {
    return {
      // 核心价值三张卡片
      coreValues: [
        {
          icon: require("@/assets/about/value_icon1.png"),
          desc: "平台通过租户隔离和角色权限体系支持同一主体的多重身份，避免把用户身份和单一业务系统绑定",
        },
        {
          icon: require("@/assets/about/value_icon2.png"),
          desc: "通过统一数字底座连接业务应用，以数据智能和AI能力提升产业协同与经营决策",
        },
        {
          icon: require("@/assets/about/value_icon3.png"),
          desc: "形成从生产到交易、从服务到运营的完整闭环，业务数据一次采集、多场景复用",
        },
      ],
      // 服务对象当前激活的层级 tab
      serviceActive: 0,
      serviceTabs: [
        {
          name: "管理与运营层",
          roles: [
            {
              title: "政府与区域管理者",
              desc: "获取产业态势、决策驾驶舱和政策服务能力，实现精准治理与科学决策，提升区域农业数字化管理水平",
              tags: ["产业监测", "政策服务"],
            },
            {
              title: "龙头企业与平台公司",
              desc: "承载区域产业项目运营和产业链协同，推动资源整合与价值共创，构建农业产业生态核心枢纽",
              tags: ["项目运营", "产业协同"],
            },
          ],
        },
        {
          name: "生产经营层",
          roles: [
            {
              title: "农业企业、农场、合作社",
              desc: "统一管理生产经营活动和供应链协同，提升运营效率与标准化水平，实现数字化精准农业管理",
              tags: ["生产管理", "供应链协同"],
            },
            {
              title: "农资门店、服务商、专家",
              desc: "提供服务目录、接单履约和结算能力，构建专业服务生态网络，连接供需双方高效匹配",
              tags: ["服务履约", "专家咨询"],
            },
          ],
        },
        {
          name: "交易与金融层",
          roles: [
            {
              title: "渠道商与消费者",
              desc: "连接产地货源与终端需求，支持交易协同，打通农产品流通最后一公里，实现产销高效对接",
              tags: ["渠道分销", "终端零售"],
            },
            {
              title: "金融机构",
              desc: "基于经营信用数据开展供应链金融协同服务，为农业经营主体注入金融活水，破解融资难题",
              tags: ["供应链金融", "信用评估"],
            },
          ],
        },
      ],
    };
  },
  methods: {
    onConsult() {
      const el = document.getElementById("message-section");
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      } else {
        window.location.hash = "#message-section";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.about {
  width: 100%;
  background: #ffffff;
}

/* ============ 顶部 banner ============ */
.banner {
  width: 100%;
  height: 564px;
  background-image: url("../../assets/about/banner.png");
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
}

.banner-inner {
  width: 1196px;
  margin: 0 auto;
  padding-top: 150px;
  font-size: 0;
}

.banner-title {
  font-size: 44px;
  font-weight: 700;
  color: #2e6be6;
  margin: 0 0 12px;
}

.banner-desc {
  width: 610px;
  font-size: 18px;
  line-height: 31px;
  color: #333333;
  margin: 0 0 80px;
}

.banner-btn {
  display: inline-flex;
  align-items: center;
  height: 44px;
  padding: 0 28px;
  background: #3982f7;
  color: #ffffff;
  font-size: 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background 0.2s ease;

  &:hover {
    background: #2e6be6;
  }

  .btn-arrow {
    width: 16px;
    height: 16px;
    margin-left: 8px;
  }
}

/* ============ 公共标题 ============ */
.section-title {
  font-size: 32px;
  font-weight: 600;
  color: #333333;
  text-align: center;
  margin: 0 0 40px;
}

/* ============ 平台定位 ============ */
.platform-section {
  padding: 80px 0;
  background: #ffffff;
}

.platform-body {
  width: 1196px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  gap: 80px;
}

.platform-img {
  margin-left: 80px;

  img {
    width: 438px;
    height: 364px;
    display: block;
  }
}

.platform-desc {
  flex: 1;
  font-size: 16px;
  line-height: 2;
  color: #333333;
  text-align: justify;
  margin: 0;
}

/* ============ 核心价值 ============ */
.value-section {
  padding: 80px 0;
  background: url("../../assets/about/bg1.png") no-repeat center;
  background-size: 100% 100%;
}

.value-grid {
  width: 1196px;
  margin: 0 auto;
  display: flex;
  gap: 20px;
}

.value-card {
  flex: 1;
  font-size: 0;
  background: #ffffff;
  border-radius: 12px;
  height: 240px;
  text-align: center;
  padding: 32px 40px 0 40px;
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 24px rgba(57, 130, 247, 0.12);
  }
}

.value-icon {
  width: 68px;
  height: 68px;
  margin-bottom: 24px;
}

.value-desc {
  font-size: 16px;
  line-height: 1.8;
  color: #333333;
  margin: 0;
}

/* ============ 服务对象 ============ */
.service-section {
  padding: 80px 0;
  background: #f5f8fe;
}

.service-card {
  width: 1196px;
  margin: 0 auto;
  background: #ffffff;
  border-radius: 20px;
  padding: 80px;
  display: flex;
  gap: 120px;
}

.service-tabs {
  flex: 0 0 300px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 24px;
}

.service-tab {
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: #333333;
  background: #fff;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0px 0px 15px 0px #3370ff14;

  &.active {
    background: url("../../assets/about/bg2.png") no-repeat center;
    background-size: 100% 100%;
    border-radius: 12px;
    color: #ffffff;
    font-weight: 500;
    box-shadow: 0 6px 16px rgba(57, 130, 247, 0.35);
  }
}

.service-content {
  flex: 1;
}

.service-role {
  margin-bottom: 32px;

  &:last-child {
    margin-bottom: 0;
  }
}

.role-title {
  font-size: 20px;
  font-weight: 500;
  color: #3982f7;
  line-height: 28px;
  margin: 0 0 16px;
}

.role-desc {
  font-size: 16px;
  line-height: 1.9;
  color: #333333;
  margin: 0 0 16px;
}

.role-tags {
  display: flex;
  gap: 12px;
}

.role-tag {
  padding: 0 8px;
  font-size: 14px;
  line-height: 26px;
  height: 28px;
  color: #3982f7;
  border: 1px solid #3982f7;
  border-radius: 4px;
  background: #ffffff;
}
</style>
